import React from 'react'

export default class DashboardSeverity extends React.Component {
  render () {
    var edadArterial
    var edadBiologica
    let { dateDashboard } = this.props

    if (this.props.edadArterial.toFixed(1) >= 85) {
      edadArterial = '> 85'
    } else {
      edadArterial = this.props.edadArterial.toFixed(1)
    }

    if (this.props.edadBiologica.toFixed(1) >= 85) {
      edadBiologica = '> 85'
    } else {
      edadBiologica = this.props.edadBiologica.toFixed(1)
    }

    return (
      <div className='severity-section'>
        <div className='time'>Fecha: {dateDashboard ? `${dateDashboard}` : '' }</div>
        <div className='severity-components'>
          <div className='result-data-values'>
            <span className='severity-data'>Edad Arterial</span>
            <span className='severity-value'>{ edadArterial + ' años'}</span>
          </div>
          <div className='result-data-values'>
            <span className='severity-data'>Edad Biológica</span>
            <span className='severity-value'>{ edadBiologica + ' años'}</span>
          </div>
          <div className='result-data-values-rcv'>
            <span className='severity-data'>RCV Total</span>
            <span>&nbsp;</span>
          </div>
        </div>
      </div>
    )
  }
}

/* Validate Props */
DashboardSeverity.propTypes = {
  edadBiologica: React.PropTypes.number,
  edadArterial: React.PropTypes.number
}



// WEBPACK FOOTER //
// ./src/components/EstaDoSaludDashboard/DashboardSeveritySection.js